import { create } from 'zustand';

/**
 * useFileViewerStore — Global file viewer state (PDF, images, etc.)
 *
 * Usage from React:
 *   const { openViewer, closeViewer } = useFileViewerStore();
 *
 * Usage from plain JS (e.g. API helpers):
 *   useFileViewerStore.getState().openViewer({ blobUrl, fileType: 'pdf', title: 'Prescription' });
 */
const useFileViewerStore = create((set) => ({
  isOpen: false,
  blobUrl: null,
  fileType: 'pdf',   // 'pdf' | 'image' | 'xlsx' | 'unknown'
  title: '',

  openViewer: ({ blobUrl, fileType = 'pdf', title = '' }) =>
    set({ isOpen: true, blobUrl, fileType, title }),

  closeViewer: () =>
    set((state) => {
      // Revoke the blob URL to free memory
      if (state.blobUrl) {
        try { URL.revokeObjectURL(state.blobUrl); } catch { /* ignore */ }
      }
      return { isOpen: false, blobUrl: null, fileType: 'pdf', title: '' };
    }),
}));

export default useFileViewerStore;
